import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Panel } from '@/components/Panel';
import { HeritageSeal } from '@/components/BrandMark';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await register(form.name, form.email, form.password);
      navigate('/console/customer');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <Panel className="p-10">
        <div className="text-center">
          <HeritageSeal size={72} />
          <div className="h-eyebrow mt-4">Create account</div>
          <div className="h-display text-3xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Welcome to Heritage</div>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="h-label">Full name</label>
            <input className="h-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reg-name" />
          </div>
          <div>
            <label className="h-label">Email</label>
            <input className="h-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" />
          </div>
          <div>
            <label className="h-label">Password</label>
            <input className="h-input" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" />
          </div>
          <button className="h-btn w-full justify-center" disabled={loading} data-testid="reg-submit">{loading ? 'Creating...' : 'Create account'}</button>
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </form>
        <div className="text-center mt-6 text-sm" style={{ color: 'var(--heritage-plum)' }}>
          Already a member? <Link to="/login" className="underline">Sign in</Link>
        </div>
      </Panel>
    </div>
  );
}
